import type { LegalDocument } from "../content/shared";

function linkedText(text: string) {
  return text.split(/(https:\/\/www\.apple\.com\/legal\/internet-services\/itunes\/dev\/stdeula\/|support@vaultpin\.app)/g).map((part) => {
    if (part === "support@vaultpin.app") return <a key={part} href="mailto:support@vaultpin.app">{part}</a>;
    if (part.startsWith("https://")) return <a key={part} href={part}>{part}</a>;
    return part;
  });
}

export function LegalPage({ document }: { document: LegalDocument }) {
  return (
    <article className="legal-page legal-width">
      <header className="legal-hero">
        <p className="eyebrow">{document.eyebrow}</p>
        <h1>{document.title}</h1>
        <p className="legal-updated">{document.updatedLabel}: <time dateTime="2026-08-24">{document.updatedDate}</time></p>
        <p className="legal-introduction">{document.introduction}</p>
      </header>
      <div className="legal-sections">
        {document.sections.map((section) => (
          <section key={section.heading}>
            <h2>{section.heading}</h2>
            {section.paragraphs.map((paragraph) => <p key={paragraph}>{linkedText(paragraph)}</p>)}
            {section.bullets && <ul>{section.bullets.map((bullet) => <li key={bullet}>{bullet}</li>)}</ul>}
          </section>
        ))}
      </div>
    </article>
  );
}
